<template>
  <CRow>
    <CCol >
      <transition name="slide">
        <CCard>
          <CCardHeader>
            Benutzer / Kunden
          </CCardHeader>
          <CCardBody>
            <CDataTable
              hover
              striped
              tableFilter
              :filterable="false"
              sorter
              :items="userlist"
              :fields="fields"
              :items-per-page="perPage"
              @row-clicked="rowClicked"
              :pagination="$options.paginationProps"
              index-column
              clickable-rows
            >
            </CDataTable>
            <button class="btn btn-success" @click="btnNewClicked">Neuer Benutzer</button>
          </CCardBody>
        </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: 'Users',
  data() {
    return {
      fields: [
        { key: 'id', label: '#',sorter:true },
        { key: 'company', label: 'Unternehmen',sorter:true },
        { key: 'username', label: 'Benutzername',sorter:true },
        { key: 'displayname', label: 'Anzeigename',sorter:true },
        { key: 'customerno', label: 'Kundennummer',sorter:true },
        { key: 'email', label: "E-Mail",sorter:true }
      ],
      perPage: 20,
    }
  },
  computed : mapGetters(["userlist"]),
  methods: {
    ...mapActions(['getUserList']),
    userLink (id) {
      return `users/${id.toString()}`
    },
    rowClicked (item, index) {
      const userLink = this.userLink(item.id)
      this.$router.push({path: userLink})
    }
    ,btnNewClicked () {
      const userLink = this.userLink(0)
      this.$router.push({path: userLink})
    }
  },
  created() {
       this.getUserList('%')
        
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  }
}
</script>
